import request from '@/utils/axios';

import {
  GET_NAMED_PARTY_FIELD_OPTIONS_BEGIN,
  GET_NAMED_PARTY_FIELD_OPTIONS_ERROR,
  GET_NAMED_PARTY_FIELD_OPTIONS_SUCCESS,
} from '../types';

const getFieldOptionsBegin = () => {
  return {
    type: GET_NAMED_PARTY_FIELD_OPTIONS_BEGIN,
    payload: {
      isFetchingOptions: true,
    },
  };
};
const getFieldOptionsError = () => {
  return {
    type: GET_NAMED_PARTY_FIELD_OPTIONS_ERROR,
    payload: {
      isFetchingOptions: false,
    },
  };
};
const getFieldOptionsSuccess = options => {
  return {
    type: GET_NAMED_PARTY_FIELD_OPTIONS_SUCCESS,
    payload: {
      isFetchingOptions: false,
      options,
    },
  };
};

export default () => {
  return async dispatch => {
    try {
      await dispatch(getFieldOptionsBegin());
      const response = await request({
        url: 'amicus/searchoptions',
        method: 'GET',
        triggerLoad: false,
      });

      if ('data' in response) {
        const {
          data: { AmicusFieldOptions },
        } = response;
        const fieldOptions = {
          statuses: AmicusFieldOptions.Statuses,
          caseNames: AmicusFieldOptions.CaseNames.filter(c => c.CaseTypeId === 2),
          issues: AmicusFieldOptions.Issues,
          states: AmicusFieldOptions.States,
        };
        await dispatch(getFieldOptionsSuccess(fieldOptions));
      }
    } catch (err) {
      console.warn(err);
      await dispatch(getFieldOptionsError());
    }
  };
};
